import React from 'react'
import { Hero } from './Hero'
import { LearnersChoose } from './LearnersChoose'
import { OurCapabilities } from './OurCapabilities'
import { Contact } from './Contact'
import { OurOfferings } from './OurOfferings'
import { VisionMission } from './VisionMission'

export const About = () => {
  return (
    <div>
        <Hero />
        <VisionMission />
        <LearnersChoose />
        <OurOfferings />
        <OurCapabilities />
        <Contact />
    </div>
  )
}
